import { Worker, Video, Request, User } from '../types';

// Use real generated poster images for the prototype
const posterMap: Record<string, string> = {
  v1a: '/posters/welder.jpg',
  v1b: '/posters/welder.jpg',
  v1c: '/posters/welder.jpg',
  v2a: '/posters/drywall.jpg',
  v2b: '/posters/drywall.jpg',
  v3a: '/posters/electrician.jpg',
  v3b: '/posters/electrician.jpg',
  v3c: '/posters/electrician.jpg',
  v4a: '/posters/plumber.jpg',
  v4b: '/posters/plumber.jpg',
  v5a: '/posters/concrete.jpg',
  v5b: '/posters/concrete.jpg',
};

function makeVideo(
  id: string,
  workerId: string,
  title: string,
  skillLabel: string,
  order: number,
  duration: number
): Video {
  return {
    id,
    workerId,
    providerVideoId: `demo-${id}`,
    posterUrl: posterMap[id] || '/posters/general.jpg',
    duration,
    title,
    skillLabel,
    order,
    status: 'visible',
  };
}

export const workers: Worker[] = [
  {
    id: 'w1',
    firstName: 'Dmitri',
    profession: 'Welder',
    specialty: 'Structural Welding',
    yearsOfExperience: 12,
    nationality: 'Ukrainian',
    countryOfOrigin: 'Ukraine',
    languages: ['English', 'Ukrainian', 'Russian'],
    status: 'published',
    heroVideoId: 'v1a',
    videos: [
      makeVideo('v1a', 'w1', 'TIG Welding Stainless Steel', 'TIG Stainless', 0, 22),
      makeVideo('v1b', 'w1', 'Arc Welding Heavy Beams', 'Arc Heavy Beams', 1, 18),
      makeVideo('v1c', 'w1', 'Pipe Welding in Position', 'Pipe Position', 2, 25),
    ],
    createdAt: '2026-06-15T08:00:00Z',
    createdBy: 'recruiter1',
  },
  {
    id: 'w2',
    firstName: 'Mohammed',
    profession: 'Drywall Installer',
    specialty: 'Gypsum Board & Finishing',
    yearsOfExperience: 8,
    nationality: 'Moroccan',
    countryOfOrigin: 'Morocco',
    languages: ['English', 'Arabic', 'French'],
    status: 'published',
    heroVideoId: 'v2a',
    videos: [
      makeVideo('v2a', 'w2', 'Installing Gypsum Ceiling Panels', 'Ceiling Panels', 0, 20),
      makeVideo('v2b', 'w2', 'Joint Taping & Mudding', 'Joint Finishing', 1, 24),
    ],
    createdAt: '2026-06-20T10:00:00Z',
    createdBy: 'recruiter2',
  },
  {
    id: 'w3',
    firstName: 'Yossi',
    profession: 'Electrician',
    specialty: 'Commercial Wiring & Panels',
    yearsOfExperience: 15,
    nationality: 'Israeli',
    countryOfOrigin: 'Israel',
    languages: ['Hebrew', 'English'],
    status: 'published',
    heroVideoId: 'v3a',
    videos: [
      makeVideo('v3a', 'w3', 'Panel Board Installation', 'Panel Board', 0, 19),
      makeVideo('v3b', 'w3', 'Conduit Bending & Routing', 'Conduit Bending', 1, 21),
      makeVideo('v3c', 'w3', 'Fault Diagnosis on Site', 'Fault Diagnosis', 2, 27),
    ],
    createdAt: '2026-07-01T08:00:00Z',
    createdBy: 'recruiter1',
  },
  {
    id: 'w4',
    firstName: 'Viktor',
    profession: 'Plumber',
    specialty: 'Industrial Piping Systems',
    yearsOfExperience: 10,
    nationality: 'Ukrainian',
    countryOfOrigin: 'Ukraine',
    languages: ['English', 'Ukrainian', 'Russian'],
    status: 'published',
    heroVideoId: 'v4a',
    videos: [
      makeVideo('v4a', 'w4', 'Copper Pipe Soldering', 'Copper Soldering', 0, 23),
      makeVideo('v4b', 'w4', 'Drainage System Assembly', 'Drainage Assembly', 1, 20),
    ],
    createdAt: '2026-04-12T09:00:00Z',
    createdBy: 'recruiter2',
  },
  {
    id: 'w5',
    firstName: 'Youssef',
    profession: 'Carpenter',
    specialty: 'Framing & Formwork',
    yearsOfExperience: 20,
    nationality: 'Egyptian',
    countryOfOrigin: 'Egypt',
    languages: ['English', 'Arabic'],
    status: 'published',
    heroVideoId: 'v5a',
    videos: [
      makeVideo('v5a', 'w5', 'Timber Frame Assembly', 'Frame Assembly', 0, 21),
      makeVideo('v5b', 'w5', 'Formwork for Concrete Pour', 'Concrete Formwork', 1, 26),
    ],
    createdAt: '2026-01-18T11:00:00Z',
    createdBy: 'recruiter1',
  },
];

export const professions = [
  'Welder',
  'Drywall Installer',
  'Electrician',
  'Plumber',
  'Carpenter',
];

export const mockRequests: Request[] = [
  {
    id: 'r1',
    workerId: 'w1',
    buyerName: 'Oren Mizrahi',
    company: 'Negev Construction Ltd.',
    phone: '+972-52-1234567',
    email: 'david@negev-build.co.il',
    message: 'Need an experienced structural welder for a 6-month bridge project in Beersheba. Starting August.',
    source: 'catalog',
    status: 'new',
    createdAt: '2026-07-12T09:30:00Z',
  },
  {
    id: 'r2',
    workerId: 'w3',
    buyerName: 'Rachel Levy',
    company: 'Ayalon Infrastructure',
    phone: '+972-54-9876543',
    email: 'rachel@ayalon-infra.co.il',
    message: 'Looking for an industrial electrician for our Tel Aviv light rail expansion. Long-term position.',
    source: 'catalog',
    status: 'in_progress',
    createdAt: '2026-07-11T14:00:00Z',
  },
  {
    id: 'r3',
    workerId: 'w4',
    buyerName: 'Yossi Barak',
    company: 'Barak Plumbing Services',
    phone: '+972-50-5554321',
    email: 'yossi@barak-plumb.co.il',
    message: 'We have a large commercial project in Haifa — need a skilled pipefitter ASAP for 3 months.',
    source: 'shared_list',
    status: 'new',
    createdAt: '2026-07-13T11:15:00Z',
  },
];

export const mockUsers: User[] = [
  { id: 'u1', email: 'admin@skillhire.co.il', role: 'admin', name: 'Oren Mizrahi' },
  { id: 'u2', email: 'recruiter1@skillhire.co.il', role: 'recruiter', name: 'Avi Shavit' },
  { id: 'u3', email: 'recruiter2@skillhire.co.il', role: 'recruiter', name: 'Maya Dahan' },
];

export function getAvailableProfessions(workersList: Worker[]): string[] {
  return [...new Set(workersList.map((w) => w.profession))].sort();
}
